<template>
  <div role="region" aria-label="Matching parks and fields">
    <nav aria-label="Breadcrumb" class="dpr-breadcrumbs">
      <v-breadcrumbs :items="breadcrumbs" divider=">"/>
    </nav>
    <v-slide-x-transition hide-on-leave>
      <div v-if="results.length != 1" key="park">
        <v-data-iterator
          :items="results"
          :rows-per-page-items="rowsPerPageItems"
          style="width:100%;"
          content-tag="v-layout"
          row
          wrap
        >
          <template v-slot:item="{ item }">
            <v-flex xs12 sm6 md4 lg3 xl2>
              <v-card class="btn-card ma-2" :to="`/index/${item.facilityLocationCode}`">
                <h4 class="card-heading text-truncate">{{item.locationName}}</h4>
                <h6 class="card-subheading">{{item.streetAddressText}}</h6>
              </v-card>
            </v-flex>
          </template>
        </v-data-iterator>
      </div>
      <div v-else key="field">
        <v-layout><v-flex xs12 sm6 md4 lg3 xl2>
        <v-card class="btn-card ma-2" :to="`/details/${results[0].fields[0].facilityLocationCode}`">
          <h4 class="card-heading">All fields in {{results[0].fields[0].locationName}}</h4>
        </v-card>
        </v-flex></v-layout>
        <v-divider class="mb-4 mt-3"/>
        <v-data-iterator
          :items="results[0].fields"
          :rows-per-page-items="rowsPerPageItems"
          style="width:100%;"
          content-tag="v-layout"
          row
          wrap
        >
          <template v-slot:item=" { item }">
            <v-flex xs12 sm6 md4 lg3 xl2>
              <v-card class="btn-card ma-2" :to="`/details/${item.facilityLocationCode}/${item.comboKeyCode}`">
                <h4 class="card-heading text-truncate">{{ item.facilityName }}</h4>
                <div class="card-spacer"/>
                <p class="card-text">
                  Type: {{item.reservationFacilityTypeCode}}<br/>
                  Lighted: {{item.lightedFieldInd ? 'Yes' : 'No'}}<br/>
                  Turf Type: {{item.fieldTurfTypeDsc}}<br/>
                  Usage: {{item.fieldUseTypeDsc}}
                </p>
              </v-card>
            </v-flex>
          </template>
        </v-data-iterator>
      </div>
    </v-slide-x-transition>
  </div>
</template>

<script>
  export default {
    props: ['results'],
    data: () => ({
      rowsPerPageItems: [
        12,
        24,
        36,
        {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}
      ]
    }),
    computed: {
      breadcrumbs: function() {
        if(this.results.length == 1)
          return [
            {
              text: 'All Matching Parks',
              disabled: false,
              to: '/index',
              exact: true
            },
            {
              text: this.results[0].locationName,
              disabled: true
            }
          ]
        else
          return [
            {
              text: 'All Matching Parks',
              disabled: true
            }
          ]
      }
    }
  }
</script>

<style scoped>
.dpr-breadcrumbs >>> .v-breadcrumbs__divider {
  color: rgba(0, 0, 0, 0.62) !important;
}
.dpr-breadcrumbs >>> .v-breadcrumbs__item:not(.v-breadcrumbs__item--disabled) {
  color: #015cb9;
  font-weight: 600;
}
.dpr-breadcrumbs >>> .v-breadcrumbs__item--disabled {
  color: rgba(0, 0, 0, 0.87) !important;
  opacity: 1 !important;
}
</style>